import React from "react";
import CommonSelect from "../../../components/forms/CommonSelect";
import {
  handleChange,
  handleChangeFile,
} from "../../../helpers/handleFormChanges";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import { AppContext } from "../../../contexts/AppContext";
import CommonInputFile from "../../../components/forms/CommonInputFile";
import PropTypes from "prop-types";

function UploadDocumentoModal({
  isOpen,
  setIsOpen,
  valuesHook,
  uploadDocumento,
}) {
  const { session } = React.useContext(AppContext);
  const { uploadValues, setUploadValues } = valuesHook;
  const [descricoes, setDescricoes] = React.useState({});
  const categorias = {
    ...(session?.codigo === "99"
      ? { 1: "Documentos pessoais", 2: "Demissionais", 3: "Admissionais" }
      : {}),
    4: "Exames médicos",
  };

  React.useEffect(() => {
    let newDescricoes;
    switch (uploadValues?.categoria) {
      case "1":
        newDescricoes = {
          1: "CNH ou RG",
          2: "Titulo de eleitor",
          4: "Termo de contrato de estágio",
        };
        break;

      case "2":
        newDescricoes = {
          5: "Termo de rescisão",
          6: "Chave de comunicação do FGTS",
          7: "Extrato FGTS",
          8: "Demonstrativo FGTS",
          9: "Requerimento do seguro desemprego",
          10: "Aviso prévio",
        };
        break;

      case "3":
        newDescricoes = {
          11: "Ficha de registro",
          12: "Contrato de experiencia",
          13: "Solicitação do vale transporte",
          14: "Declaração de salário família e IRRF",
        };
        break;

      case "4":
        newDescricoes = {
          ...(session?.codigo === "99" ? { 3: "Exame admissional" } : {}),
          15: "Exame periódico",
          16: "Exame demissional",
        };
        break;

      default:
        newDescricoes = {};
        break;
    }
    setDescricoes(newDescricoes);
  }, [session?.codigo, uploadValues?.categoria]);

  return (
    <CommonModal
      title={"Novo documento do colaborador"}
      is_open_modal={isOpen}
      set_is_open_modal={setIsOpen}
      size="xl"
      buttons={
        <CommonButton
          key={`upload-documento`}
          onClick={() => {
            uploadDocumento();
          }}
          color="success"
        >
          Upload
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-md-3 mb-3">
          <CommonSelect
            label="Categoria"
            id="categoria"
            value={uploadValues.categoria}
            onChange={(e) => {
              handleChange(e, uploadValues, setUploadValues);
            }}
            data={Object.keys(categorias).map((id) => ({
              text: categorias[id],
              id: id,
            }))}
            placeholder="Selecione a identificação"
            required
          />
        </div>
        <div className="col-md-3 mb-3">
          <CommonSelect
            label="Descricao"
            id="descricao"
            value={uploadValues.descricao}
            onChange={(e) => {
              handleChange(e, uploadValues, setUploadValues);
            }}
            data={Object.keys(descricoes).map((id) => ({
              text: descricoes[id],
              id: id,
            }))}
            placeholder="Selecione"
            required
          />
        </div>
        <div className="col-md-6 mb-3">
          <CommonInputFile
            label="Selecione o arquivo"
            id="arquivo"
            onChange={(e) => handleChangeFile(e, uploadValues, setUploadValues)}
            required
            accept="application/pdf,image/*"
          />
        </div>
      </div>
    </CommonModal>
  );
}

UploadDocumentoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  valuesHook: PropTypes.shape({
    uploadValues: PropTypes.object.isRequired,
    setUploadValues: PropTypes.func.isRequired,
  }).isRequired,
  uploadDocumento: PropTypes.func.isRequired,
};

export default UploadDocumentoModal;
